import React from 'react';
import ClientLogo from './ClientLogo';

/** Exactly six client logos per row (same card style for every row). */
const ClientLogoStrip = ({ clients = [], accent = 'primary', className = '' }) => {
  const row = clients.slice(0, 6);
  const ringClass = accent === 'secondary' ? 'ring-secondary-200/80' : 'ring-primary-200/80';

  if (!row.length) return null;

  return (
    <div className={`w-full ${className}`}>
      <div className="grid grid-cols-6 gap-2 sm:gap-3 lg:gap-4">
        {row.map((client) => (
          <div
            key={client.slug}
            className={`flex min-w-0 flex-col items-center justify-center rounded-xl bg-white px-2 py-4 shadow-sm ring-1 sm:px-3 sm:py-5 ${ringClass}`}
          >
            <ClientLogo
              client={client}
              size="lg"
              showName
              nameClassName="line-clamp-3 text-[9px] sm:text-[10px] lg:text-xs"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export function chunkClientsBySix(clients) {
  const rows = [];
  for (let i = 0; i < clients.length; i += 6) {
    rows.push(clients.slice(i, i + 6));
  }
  return rows;
}

export default ClientLogoStrip;
